export default __webpack_public_path__ + "static/education-b1872ae1050afcd69f557376fccf0f34.svg";